/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DictUnitOfMeasure
 */
export interface DictUnitOfMeasure {
    /**
     * 
     * @type {string}
     * @memberof DictUnitOfMeasure
     */
    code: string;
    /**
     * 
     * @type {boolean}
     * @memberof DictUnitOfMeasure
     */
    isBaseUnit: boolean;
}

export function DictUnitOfMeasureFromJSON(json: any): DictUnitOfMeasure {
    return DictUnitOfMeasureFromJSONTyped(json, false);
}

export function DictUnitOfMeasureFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictUnitOfMeasure {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'isBaseUnit': json['isBaseUnit'],
    };
}

export function DictUnitOfMeasureToJSON(value?: DictUnitOfMeasure | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'isBaseUnit': value.isBaseUnit,
    };
}


